import {ProductsRelDocs} from "../../interfaces";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const PRDBannerAbove = (props: IProductBuyButtonProps) => {

    const product = props.product;

    return (

            <>
                {
                    <div className="banner-above w-full flex flex-wrap justify-start mb-4">
                        <div className="w-full" dangerouslySetInnerHTML={{ __html: product.bannerAbove }} />
                    </div>
                }
            </>
    )
};

export default PRDBannerAbove;